// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const Toaster = registerClientReference(
    function() { throw new Error("Attempted to call Toaster() from the server but Toaster is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/nextapp/node_modules/sonner/dist/index.mjs <module evaluation>",
    "Toaster",
);
export const toast = registerClientReference(
    function() { throw new Error("Attempted to call toast() from the server but toast is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/nextapp/node_modules/sonner/dist/index.mjs <module evaluation>",
    "toast",
);
export const useSonner = registerClientReference(
    function() { throw new Error("Attempted to call useSonner() from the server but useSonner is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/nextapp/node_modules/sonner/dist/index.mjs <module evaluation>",
    "useSonner",
);
